import React, {Component} from 'react';
import AppUsers from '../users/app-users';
import DatabaseConnection from '../database/database-connection';
import DatabaseEnv from '../database/database-env';
import Context from '../context/context';
import UserProfileAdmin from '../user-profile-admin/user-profile-admin';
import LineageConfig from './lineage-config';

import {Col, Row} from 'react-bootstrap';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appContentContainer: 'app-content-container',
      mainPageClass: 'page-content select-container in',
      subPageClass: 'page-content results-container',
      pageNavContainer: 'hide',
      showModule: null,
    };
  }


  componentDidUpdate(prevProps) {
  }


  navigateToBegin=()=>{
    this.setState({
      appContentContainer: 'app-content-container',
      mainPageClass: 'page-content select-container in',
      subPageClass: 'page-content results-container',
      pageNavContainer: 'hide',
    });
  };


  hideBackNavigation=()=>{
    this.setState({
      appContentContainer: 'app-content-container',
      pageNavContainer: 'hide',
    });
  };


  goToTop=()=>{
    document.getElementById('app').scrollTo(0, 0);
  };

  dropdownSelector = (name, id, value) => {
    this.setState({[name]: value});
  };

  dismissBanner = () => {
    this.setState({showBanner: false});
  };

  snackHandler = (state) =>{
    this.setState({snackbarStatus: state});
  };


  selectModule=(name)=>{
    this.setState({
      showModule: name,
      appContentContainer: 'app-content-container in',
      mainPageClass: 'page-content select-container',
      subPageClass: 'page-content results-container in',
      pageNavContainer: 'page-nav-container',
    });
  };


  goBack = (level) => {
    if (level===0) {
      this.setState({
        appContentContainer: 'app-content-container',
        mainPageClass: 'page-content select-container in',
        subPageClass: 'page-content results-container',
        pageNavContainer: 'hide',
        showModule: null,
      });
    } else if (level===1) {
      this.setState({
        pageNavContainer: 'page-nav-container',
      });
    } else if (level===2) {
      this.setState({
        pageNavContainer: 'hide',
      });
    }
  };


  render() {
    return (
      <div className={this.state.appContentContainer}>


        <div className={this.state.pageNavContainer}>
          <a onClick={this.goBack.bind(this, 0)} className="back-link">
            <i className="material-icons">arrow_back</i>
           Admin Panel
          </a>
        </div>


        <div id='' className={this.state.mainPageClass}>
          <h2>Admin Panel</h2>
          <Row className='extendable-height'>

            <Col sm={4} xs={6}>
              <div className='recon-results-card menu-card' onClick={this.selectModule.bind(this, 'user')}>
                <span className="material-icons">group</span>
                <h3>Users</h3>
                <div className="desc">Manage users in Skokie.</div>
              </div>
            </Col>

            <Col sm={4} xs={6}>
              <div className='recon-results-card menu-card' onClick={this.selectModule.bind(this, 'connection')}>
                <span className="material-icons">storage</span>
                <h3>Database Connection</h3>
                <div className="desc">Manage your database connections.</div>
              </div>
            </Col>

            <Col sm={4} xs={6}>
              <div className='recon-results-card menu-card' onClick={this.selectModule.bind(this, 'context')}>
                <span className="material-icons">picture_in_picture</span>
                <h3>Context</h3>
                <div className="desc">Manage projects/context for your organization.</div>
              </div>
            </Col>

          </Row>

          <Row className='extendable-height'>

            <Col sm={4} xs={6}>
              <div className='recon-results-card menu-card' onClick={this.selectModule.bind(this, 'env')}>
                <span className="material-icons">call_made</span>
                <h3>Environment</h3>
                <div className="desc">Manage data environment names & codes.</div>
              </div>
            </Col>

            <Col sm={4} xs={6}>
              <div className='recon-results-card menu-card' onClick={this.selectModule.bind(this, 'userprofileadmin')}>
                <span className="material-icons">manage_accounts</span>
                <h3>User Profile Administration</h3>
                <div className="desc">Manage user roles, permissions, and overrides.</div>
              </div>
            </Col>

            <Col sm={4} xs={6}>
              <div
                className='recon-results-card menu-card'
                onClick={this.selectModule.bind(this, 'lineageconfig')}
                data-testid="admin-tile-lineageconfig"
              >
                <span className="material-icons">account_tree</span>
                <h3>Lineage Configuration</h3>
                <div className="desc">Manage the global lineage theme, characteristics, and node references.</div>
              </div>
            </Col>

          </Row>

        </div>


        <div className={this.state.subPageClass}>

          {this.state.showModule==='user'? <AppUsers parentNavBar={this.goBack.bind(this)} /> : null}

          {this.state.showModule==='connection'? <DatabaseConnection parentNavBar={this.goBack.bind(this)} /> : null}

          {this.state.showModule==='env'? <DatabaseEnv parentNavBar={this.goBack.bind(this)} /> : null}

          {this.state.showModule==='context'? <Context parentNavBar={this.goBack.bind(this)} /> : null}

          {this.state.showModule==='userprofileadmin'? (
          <UserProfileAdmin
            parentNavBar={this.goBack.bind(this)}
            history={this.props.history}
          />
        ) : null}

          {this.state.showModule==='lineageconfig'? (
          <LineageConfig parentNavBar={this.goBack.bind(this)} />
        ) : null}


        </div>


      </div>
    );
  }
}


export default Admin;
